import {
    sortingOptionsAriaLabel,
    filteringOptionsAriaLabel,
} from '../../../strings.locstring.json';
import loc from 'owa-localize';
import { toFilterName } from '../../../utils/personaListFilterUtils';
import { getFilterAriaLabel, getSortByAriaLabel } from '../../../utils/listFilterUtils';
import { toSortingName } from '../../../utils/personaListSortUtils';
import type { PersonaListViewModel } from '../../../models/PersonaListViewModel';

export function createListFilterAriaLabel(
    viewState: PersonaListViewModel,
    isInSearch: boolean,
    hideFilterFromDropDown: boolean
): string {
    let ariaLabel = '';

    if (hideFilterFromDropDown) {
        ariaLabel += loc(sortingOptionsAriaLabel);
    } else {
        ariaLabel += loc(filteringOptionsAriaLabel) + '. ';
        ariaLabel += getFilterAriaLabel(toFilterName(viewState.filter), true);
    }

    if (!isInSearch) {
        ariaLabel += '. ' + getSortByAriaLabel(toSortingName(viewState.sorting), true);
    }

    return ariaLabel;
}
